
export const icaoRegex = /(?:^| )([A-Z]{4}) /;
export const seriesRegex = /SIGMET ([A-Z]+)[ ]?([0-9]{1,2})/;
export const validityRegex = /VALID (?:([0-9]{6})\/([0-9]{6})|UNTIL ([0-9]{6}))/;

export const sigmetBodyRegex = /VALID (?:[0-9]{6}\/[0-9]{6}|UNTIL [0-9]{6}) (.+)/;

